import {useUpmPlant} from '@hconnect/upm'
import {useCallback} from 'react'

import {ColorPreview} from './ColorPreview'
import {MaterialColorSelector} from './MaterialColorSelector'

import {useCanEditColors} from '@refra/modules/common/hooks'
import {useUpdateRefractoryCustomization} from '@refra/modules/common/hooks/mutations/customizations'
import type {CatalogLocalColorCellProps} from '@refra/modules/common/types'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const CatalogLocalColorCell: React.FC<CatalogLocalColorCellProps> = ({
  refractoryId,
  globalColor,
  localColor: localColorProp,
  dataCy = 'catalog-local-color'
}) => {
  const canEditColors = useCanEditColors()
  const {mutate: updateCustomization} = useUpdateRefractoryCustomization()

  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})

  const handleColorChange = useCallback(
    (refractoryId: number, color: string) => {
      updateCustomization({
        plantUpmId: upmPlant.upmId,
        refractoryId,
        color
      })
    },
    [upmPlant.upmId, updateCustomization]
  )

  const handleColorReset = useCallback(
    (refractoryId: number) => {
      updateCustomization({
        plantUpmId: upmPlant.upmId,
        refractoryId,
        color: null
      })
    },
    [upmPlant.upmId, updateCustomization]
  )

  if (!canEditColors) {
    return <ColorPreview color={localColorProp ?? globalColor} dataCy={`${dataCy}-preview`} />
  }

  return (
    <MaterialColorSelector
      refractoryId={refractoryId}
      globalColor={globalColor}
      localColor={localColorProp}
      showResetButton={false}
      hideAddButtonWhenLocalColorSet={true}
      showGlobalColorAsFallback={true}
      showSelectedOutline={false}
      isDisabled={!canEditColors}
      onColorChange={handleColorChange}
      onColorReset={handleColorReset}
      dataCy={dataCy}
    />
  )
}
